import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import ScrollToTop from './components/ScrollToTop';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Footer from './components/Footer';
import CookiePopup from './components/CookiePopup';
import AccessibilityWidget from './components/AccessibilityWidget';
import ImpactPage from './pages/ImpactPage';
import AboutPage from './pages/AboutPage';
import JoinPage from './pages/JoinPage';
import RestaurantPage from './pages/RestaurantPage';
import LegalPage from './pages/LegalPage';
import PrivacyPage from './pages/PrivacyPage';
import BlogListPage from './pages/BlogListPage';
import BlogArticlePage from './pages/BlogArticlePage';
import DocsPage from './pages/DocsPage';
import NotFoundPage from './pages/NotFoundPage';
import { EstablishmentAuthProvider } from './context/EstablishmentAuthContext';
import EstablishmentLoginPage from './pages/establishment/LoginPage';
import EstablishmentLayout from './pages/establishment/EstablishmentLayout';
import EstablishmentProtectedRoute from './pages/establishment/ProtectedRoute';
import EstablishmentDashboardPage from './pages/establishment/DashboardPage';
import EstablishmentCrousDetailPage from './pages/establishment/CrousDetailPage';
import EstablishmentLogsPage from './pages/establishment/LogsPage';
import EstablishmentRequestAccessPage from './pages/establishment/RequestAccessPage';
import EstablishmentActivationPage from './pages/establishment/ActivationPage';

function PublicShell({ children }) {
  return (
    <div className="App">
      <a href="#main-content" className="a11y-skip-link">Aller au contenu principal</a>
      <Navbar />
      <main id="main-content">{children}</main>
      <AccessibilityWidget />
      <CookiePopup />
    </div>
  );
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <EstablishmentAuthProvider>
        <Routes>
          {/* Establishment admin panel (no public navbar / no footer) */}
          <Route
            path="/etablissement/login"
            element={<EstablishmentLoginPage />}
          />
          <Route
            path="/etablissement/demande-acces-partenaire"
            element={<EstablishmentRequestAccessPage />}
          />
          <Route
            path="/etablissement/activation"
            element={<EstablishmentActivationPage />}
          />
          <Route
            path="/etablissement/gestion"
            element={
              <EstablishmentProtectedRoute>
                <EstablishmentLayout />
              </EstablishmentProtectedRoute>
            }
          >
            <Route index element={<EstablishmentDashboardPage />} />
            <Route path="ru/:crousId" element={<EstablishmentCrousDetailPage />} />
            <Route path="logs" element={<EstablishmentLogsPage />} />
          </Route>

          {/* Public website */}
          <Route
            path="/"
            element={<PublicShell><Hero /><Footer /></PublicShell>}
          />
          <Route
            path="/impact"
            element={<PublicShell><ImpactPage /><Footer /></PublicShell>}
          />
          <Route
            path="/about"
            element={<PublicShell><AboutPage /><Footer /></PublicShell>}
          />
          <Route
            path="/join"
            element={<PublicShell><JoinPage /><Footer /></PublicShell>}
          />
          <Route
            path="/etablissement"
            element={<PublicShell><RestaurantPage /><Footer /></PublicShell>}
          />
          <Route
            path="/legal"
            element={<PublicShell><LegalPage /><Footer /></PublicShell>}
          />
          <Route
            path="/privacy"
            element={<PublicShell><PrivacyPage /><Footer /></PublicShell>}
          />
          <Route
            path="/docs"
            element={<PublicShell><DocsPage /><Footer /></PublicShell>}
          />
          <Route
            path="/blog"
            element={<PublicShell><BlogListPage /><Footer /></PublicShell>}
          />
          <Route
            path="/blog/:slug"
            element={<PublicShell><BlogArticlePage /><Footer /></PublicShell>}
          />
          <Route
            path="*"
            element={<PublicShell><NotFoundPage /><Footer /></PublicShell>}
          />
        </Routes>
      </EstablishmentAuthProvider>
    </Router>
  );
}

export default App;
